// extracted by mini-css-extract-plugin
export var banner = "_hg-0";
export var closeButton = "_hg-2";
export var greenCheckmark = "_hg-3";
export var hereLink = "_hg-4";
export var titleIcon = "_hg-1";